import { useTranslation } from "react-i18next";
import FormSection from "../../../../../../common/components/functional/formSection/FormSection";
import OrderSupplements from "../../../../additionalInfo/OrderSupplements";
import { useFormContext } from "react-hook-form";
import { FormKeys } from "../helpers";
import { Dispatch, SetStateAction } from "react";
import { VariationSpecificSettings } from "../../../../../supplements/supplementAPI";
import {
  WORK_AGREEMENT_ACCEPTED,
  WORK_AGREEMENT_DECLINED,
} from "../../../../constants";

type Props = {
  setPeriodStartDateIsRequired?: Dispatch<SetStateAction<boolean | null>>;
};

export const Supplements = ({ setPeriodStartDateIsRequired }: Props) => {
  const { t } = useTranslation();
  const { setValue, watch, getValues } = useFormContext();

  const { tesId, tesVariation, supplements, workStarts } = watch();

  const status = getValues("status");
  const isReadOnly: boolean =
    status === WORK_AGREEMENT_ACCEPTED || status === WORK_AGREEMENT_DECLINED;

  const onSupplementsChange = (name: string, value: any) => {
    setValue(`${name}`, value);
  };

  /**
   * If date or TES variations change, we call fetchSupplementDefinitions inside Supplements
   * which is actually "/working/qry/variationSpecificSettings".
   *
   * In the query response data we also get settings that affect Work Agreement form.
   *
   * In this function we save those settings to the form state so the form can be shown correctly.
   *
   * Affected fields:
   * - Jaksotyöaika / Viikkotyöaika
   * - Jakso alkaa
   * - Tasoittumiskausi
   */
  const handleVariationSpecificSettings = (data: VariationSpecificSettings) => {
    setValue(
      FormKeys.PeriodStartDateIsRequired,
      data.periodStartDateIsRequired,
    );
    setValue(FormKeys.PeriodType, data.periodType);
    setValue(FormKeys.IsAveragingPeriodInUse, data.isAveragingPeriodInUse);
  };

  // TODO design has "Muokkaa" buttons for rows, but below implementation has "Poista" buttons only
  // -> Which is correct?
  return (
    <FormSection title={t("talentProfile:showToCustomerSupplement")}>
      <OrderSupplements
        tesId={tesId}
        tesVariation={tesVariation}
        supplements={supplements}
        onOrderTemplateChange={onSupplementsChange}
        editable={!isReadOnly}
        handleVariationSpecificSettings={handleVariationSpecificSettings}
        setPeriodStartDateIsRequired={setPeriodStartDateIsRequired}
        date={workStarts}
      />
    </FormSection>
  );
};
